import React, { useState } from "react";
import "./raceNumber.css";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import PrimaryButton from "../../../../components/primaryButton";
import { setRaceNum } from "../../../../redux/actions/race-number-action";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel } from "swiper/modules";
import "swiper/css";
import "swiper/css/mousewheel";
import { setCustomConfigData } from "../../../../redux/actions/custom-config-data-action";

const raceNumber = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

function KitModal({ kitModal, onRaceNumModal, setAddKit, enableReset }) {
  const [firstNum, setFirstNum] = useState("0");
  const [lastNum, setSecondNum] = useState("0");

  const dispatch = useDispatch();
  const customConfigData = useSelector((state) => state.customConfigData.data);

  const onApply = () => {
    customConfigData?.accessoriesData?.map((element) => {
      element?.data?.map((r) => {
        if (r.ProductCode === "N7320940") {
          r.cartStatus = true;
        }
      });
    });

    const firstRaceNum = customConfigData?.raceNumber?.find(
      (el) => el.raceNumber === firstNum.toString() && el.isLeft === true
    );

    const lastRaceNum = customConfigData?.raceNumber?.find(
      (el) => el.raceNumber === lastNum.toString() && el.isLeft === false
    );

    dispatch(
      setRaceNum({
        id1: "" + firstRaceNum.partNumber,
        id2: "" + lastRaceNum.partNumber,
        status: false,
      })
    );

    dispatch(setCustomConfigData(structuredClone(customConfigData)));
  };

  const handleFirstNumChange = (swiper) => {
    const activeIndex = swiper.realIndex;
    const selectedValue = raceNumber[activeIndex];
    setFirstNum(selectedValue);
  };
  const handleSecondNumChange = (swiper) => {
    const activeIndex = swiper.realIndex;
    const selectedValue = raceNumber[activeIndex];
    setSecondNum(selectedValue);
  };

  return (
    <div
      style={{
        backgroundColor: "#DEDEDE",
        border: "1px solid #B6B6B6",
        zIndex: "1",
        width: "auto",
        borderRadius: "0.75rem",
        display: " flex",
        flexDirection: "row",
        boxShadow: "0px 3px 6px #00000029",
        opacity: 0.99,
      }}
      className="race_num_container"
    >
      <div className="race_num__body_container">
        <div className="race_num_header">Enter Race Number</div>
        <div className="race_count_container">
          <Swiper
            direction={"vertical"}
            slidesPerView={1}
            loop={true}
            spaceBetween={22.5}
            mousewheel={true}
            modules={[Mousewheel]}
            onSlideChange={(swiper) => handleFirstNumChange(swiper)}
            className="carousel_container"
          >
            {raceNumber.map((item) => {
              return (
                <SwiperSlide
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  className="race_count"
                >
                  {item}
                </SwiperSlide>
              );
            })}
          </Swiper>

          <Swiper
            direction={"vertical"}
            slidesPerView={1}
            spaceBetween={22.5}
            loop={true}
            mousewheel={true}
            modules={[Mousewheel]}
            onSlideChange={(swiper) => handleSecondNumChange(swiper)}
            className="carousel_container"
          >
            {raceNumber.map((item) => {
              return (
                <SwiperSlide
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  className="race_count"
                >
                  {item}
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
        <div className="race_num_desc">
          Scroll the dials to select the digit
        </div>
        <div className="btn_container">
          <PrimaryButton
            label={"Apply"}
            className="apply_btn"
            size="small"
            onClick={() => {
              onApply();
              onRaceNumModal(false);
            }}
          />
          <PrimaryButton
            label={"Cancel"}
            className="cancel_btn"
            size="small"
            onClick={() => {
              onRaceNumModal(false);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default KitModal;
